export default __webpack_public_path__ + "static/media/alfAwardMobile.23a1a626.jpg";